







    import {Component, Prop, Vue, Watch} from "vue-property-decorator";
    import {Route} from "vue-router";
    import {TrackingService} from "@/services/tracking.service";
    import {User} from "@/services/auth.service";

interface IMenuItem {
    label: string;
    link: string;
    active: boolean;
    privilege?: string;
}

@Component({
    name: "Navigator"
})
export default class Navigator extends Vue {

    @Prop()
    public user!: User;

    private currentItem: IMenuItem | undefined;
    private tracking!: TrackingService;

    private menuItems: IMenuItem[] = [
        { label: "Home", link: "/", active: false },
        { label: "Projects", link: "/projects", active: false },
        { label: "Tools", link: "/tools", active: false },
        { label: "Forum", link: "/forum", active: false },
        { label: "About", link: "/about", active: false },
        { label: "Contact", link: "/contact", active: false },
        { label: "Admin", link: "/admin", active: false, privilege: "ADMIN" },
    ]

    private getItem(path: string): IMenuItem | undefined {
        for (const item of this.menuItems) {
            if (item.link === path) {
                return item;
            }
        }

        return void 0;
    }

    private async mounted() {
        this.tracking = new TrackingService();

        if (this.currentRoute.name === "Home") {
            this.currentItem = this.getItem(this.currentRoute.path);
            if (this.currentItem) this.currentItem.active = true;
            this.tracking.trackPageVisit("Home");
        }
    }

    @Watch("currentRoute")
    private routeChange(currentRoute: Route) {
        if (this.currentItem) {
            this.currentItem.active = false;
        }
        this.currentItem = this.getItem(currentRoute.path);
        document.title = "Hadev" + (this.currentRoute.name === "Home" ? "" : " - " + currentRoute.name);
        if (this.currentItem) {
            this.currentItem.active = true;
        }
        this.tracking.trackPageVisit(currentRoute.name as string);
    }

    private goto(item: IMenuItem) {
        if (!this.currentItem || item.link !== this.currentItem.link)
            this.$router.push({name: item.label});
    }

    private canShow(item: IMenuItem) {
        if (item.privilege) {
            if (!this.user) return false;
            for (const privilege of this.user.privileges) {
                if (privilege === item.privilege) {
                    return true;
                }
            }
            return false;
        }
        return true;
    }

    private get currentRoute() {
        return this.$route;
    }
}

